export const LiveIndicatorBadge = ({ viewerCount }) => {
    return (<span className="inline-flex items-center gap-1.5 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-md">
			<span className="w-2 h-2 bg-white rounded-full animate-pulse"/>
			LIVE
			{typeof viewerCount === 'number' && (<span className="text-white/80 font-normal">
					{new Intl.NumberFormat('en-US').format(viewerCount)}
				</span>)}
		</span>);
};
